import { render } from "./InputGroup.vue?vue&type=template&id=b7f52a8c"
import script from "./InputGroup.vue?vue&type=script&lang=js"
export * from "./InputGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__